export const info = {
  invTrans: {
    noRecords: 'No hay transacciones para mostrar, por favor aplique un filtro diferente.',
    noRecordsTitle: 'Nada aquí todavía!',
    active: 'Activo',
    inactive: 'Inactivo',
    deleted: 'Eliminado',
  },
};
